/**
 * Redirect middleware for broken/legacy category links.
 * Maps old paths to their correct new paths.
 */

const redirectMap = {
  '/categories/full/safety-footwear./accessories-l4': '/categories/full/safety-footwear-l3/footwear-accessories-l4',
  '/categories/full/workwear/workwear-clothing/thermals': '/categories/full/workwear/workwear-clothing-l4/thermals',
  '/categories/full/workwear/workwear-clothing/accessories': '/categories/full/workwear/workwear-clothing-l4/accessories-l5',
  '/categories/full/ppe/hearing-protection': '/categories/full/ppe/hearing-protection-l4',
  '/categories/full/ppe/hearing-protection/ear-defenders': '/categories/full/ppe/hearing-protection-l4/ear-defenders',
  '/categories/full/ppe/head-protection/safety-helmets': '/categories/full/ppe/head-protection-l4/safety-helmets',
  '/categories/full/workplace-and-facilities/first-aid/first-aid-kits': '/categories/full/workplace-and-facilities-l3/first-aid/first-aid-kits',
  '/categories/full/cleaning-and-hygiene': '/categories/full/cleaning-and-hygiene-l3',
  '/cms/download': '/help',
};

const prefixRedirectMap = {
  '/cms/news': '/news',
};

export function redirectMiddleware(to, from, next) {
  var newPath = redirectMap[to.path];

  if (newPath) {
    return next({ path: newPath, query: to.query, replace: true });
  }

  for (var prefix in prefixRedirectMap) {
    if (to.path === prefix || to.path.startsWith(prefix + '/')) {
      var mappedBase = prefixRedirectMap[prefix];
      var newPrefixPath = mappedBase + to.path.slice(prefix.length);
      return next({ path: newPrefixPath, query: to.query, replace: true });
    }
  }

  next();
}